import React from 'react';
import { FiArrowLeft } from "react-icons/fi";

const stepTwo = ({ name, setName, setStep, submitError, handleSubmitName }: any) => {
  return (
    <form>
      <label className="zs-label zs-label-required">Name</label>
      <input
        type="text"
        placeholder="Enter Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        aria-invalid={submitError ? true : undefined}
        className="zs-input h-11"
      />
      {submitError && <p className="zs-error">{submitError}</p>}
      <div className="mt-6 flex items-center justify-between gap-3">
        <button onClick={() => setStep(1.5)} type="button" className="zs-btn zs-btn-ghost">
          <FiArrowLeft aria-hidden="true" />
          Back
        </button>
        <button
          type="submit"
          onClick={handleSubmitName}
          className="zs-btn zs-btn-primary min-w-[120px]">Next</button>
      </div>
    </form>
  );
};

export default stepTwo;
